module.exports = __webpack_public_path__ + "img/index06.633a4a94.png";